<template>
  <div class="statistics">
    <a-layout style="background-color: black">
      <a-layout>
        <a-layout-content
          :style="{ background: '#2F3D4F', padding:'20px', minHeight: '300px' }"
        >
          <div class="header">
            <div class="img">
              <img :src="url">
            </div>
            <div class="description">
              <p>设备名称：{{deviceName}}</p>
              <p>设备编号：{{deviceCode}}</p>
            </div>
            <div class="input">
              <el-date-picker
                v-model="dateValue"
                type="daterange"
                align="right"
                unlink-panels
                :start-placeholder="formatDate(nowDateStart)"
                :end-placeholder="formatDate(nowDateEnd)"
                :picker-options="pickerOptions"
                style="background-color: #2F3D4F;"
                @change="onDateChange"
              />
              <button class="search" @click="search">查询</button>
            </div>
            <ul class="dataList">
              <li v-for="(item, index) in dataList" :key="index">
                <input type="checkbox" :checked="item.checked" @change="onChange($event,index,item)">
                {{item.name}} ({{item.unit}})
              </li>
            </ul>
          </div>
          <div class="container" v-show="isChartsShow">
            <ul class="charts">
              <li :key="deviceName">
                <h3>汇总</h3>
                <hr>
                <div :id="deviceName"></div>
              </li>
              <li v-for="item in dataList" :key="item.code" v-show="item.checked">
                <h3>{{item.name}}</h3>
                <hr>
                <div :id="item.name"></div>
              </li>
            </ul>
          </div>
          <a-spin size="large" v-show="!isChartsShow" />
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>

<script>
import url from '@/assets/product.png'
import { deviceApi } from '@/api/station'
import { message } from 'ant-design-vue'
import formatDate from '@/components/function/formatDate.js'
export default {
  name: 'StatisticsGroup',
  data () {
    return {
      collapsed: false,
      url,
      dataList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 31)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      dateValue: '',
      nowDateStart: '',
      nowDateEnd: '',
      startDate: '',
      endDate: '',
      isChartsShow: false,
      dataPointCode: [],
      historyData: [],
      historyList: [],
      device: {},
      date: '',
      selectedDataList: [],
      xAxisData: [],
      totalChart: null,
      totalOption: null,
      deviceName: '',
      deviceCode: ''
    }
  },
  async mounted () {
    this.deviceName = this.$store.state.deviceInfo.deviceName
    this.deviceCode = this.$store.state.deviceInfo.deviceCode
    this.nowDateStart = new Date(new Date().toDateString()).getTime()
    this.nowDateEnd = this.nowDateStart + 24 * 60 * 60 * 1000 - 1
    this.startDate = this.nowDateStart
    this.endDate = this.nowDateEnd
    this.date = this.formatDate(this.nowDateStart)
    try {
      const result = await deviceApi.getDataPoints(this.deviceCode)
      if (result.data) {
        result.data.points.forEach(item => {
          item.checked = false
          this.dataPointCode.push(item.code)
        })
        this.dataList = result.data.points
      }
      const startTime = this.nowDateStart
      const endTime = this.nowDateEnd
      const params = {
        deviceCode: this.deviceCode,
        dataPointCode: this.dataPointCode + '',
        startTime,
        endTime
      }
      const historyList = await deviceApi.getHistory(params)
      this.historyList = historyList.data
      this.historyList.forEach(history => {
        this.xAxisData.push(history.time)
      })
    } catch {
      // this.$message.error("请求失败")
    }
    this.isChartsShow = true
    this.initCharts()
    this.drawTotalChart()
  },
  methods: {
    formatDate,
    initCharts () {
      for (let i = 0; i < this.dataList.length; i++) {
        this.historyData.push([])
      }
      this.historyData.push([])
      for (let i = 0; i < this.historyList.length; i++) {
        this.historyList[i].time = (new Date(this.historyList[i].time)).getTime()
        this.historyData[0].push(this.historyList[i].time)
        for (let j = 1; j < this.historyData.length; j++) {
          const code = this.dataList[j - 1].code
          this.historyData[j].push(this.historyList[i][code])
        }
      }
      this.myEcharts(this.dataList, this.historyData)
    },
    myEcharts (dataList, historyData) {
      for (let i = 0; i < dataList.length; i++) {
        var myChart = this.$echarts.init(
          document.getElementById(dataList[i].name),
          null,
          {
            renderer: 'canvas',
            useDirtyRect: false,
            width: 1500,
            height: 240
          }
        )
        var option
        const data = []
        for (let j = 0; j < historyData[0].length; j++) {
          data.push([historyData[0][j], historyData[i + 1][j]])
        }
        option = {
          tooltip: {
            trigger: 'axis',
            position: function (pt) {
              return [pt[0], '10%']
            }
          },
          xAxis: {
            type: 'time',
            boundaryGap: false
          },
          yAxis: {
            type: 'value',
            boundaryGap: [0, '100%']
          },
          dataZoom: [
            {
              type: 'inside',
              start: 0,
              end: 20
            },
            {
              start: 0,
              end: 20
            }
          ],
          series: [
            {
              name: dataList[i].name,
              type: 'line',
              smooth: true,
              symbol: 'none',
              areaStyle: {},
              data,
              markPoint: {
                data: [
                  {
                    type: 'max',
                    name: '最大值'
                  },
                  {
                    type: 'min',
                    name: '最小值'
                  }
                ]
              }
            }
          ]
        }
        if (option && typeof option === 'object' && data) {
          myChart.setOption(option)
        }
        window.addEventListener('resize', myChart.resize)
      }
    },
    drawTotalChart () {
      this.totalChart = this.$echarts.init(
        document.getElementById(this.deviceName),
        null,
        {
          renderer: 'canvas',
          useDirtyRect: false,
          width: 1500,
          height: 240
        }
      )
      this.totalOption = {
        tooltip: {
          trigger: 'axis',
          position: function (pt) {
            return [pt[0], '10%']
          },
          formatter: params => {
            let dataStr = `<div><p style="margin:0 8px 15px;">${params[0].axisValueLabel}</p></div>`
            params.forEach(item => {
              if (this.selectedDataList.findIndex(selectedData => selectedData.name === item.seriesName) > -1) {
                dataStr += `<div>
                <div style="margin: 0 8px;">
                  ${item.marker}
                  <span>${item.seriesName}</span>
                  <span style="float:right;color:#666;margin-left:20px;font-weight:550">${item.data[1]}</span>
                </div>
              </div>`
              }
            })
            return dataStr
          }
        },
        grid: {
          containLabel: true
        },
        xAxis: {
          type: 'time',
          boundaryGap: false
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 20
          },
          {
            start: 0,
            end: 20
          }
        ]
      }
      if (this.totalOption && typeof this.totalOption === 'object') {
        this.totalChart.setOption(this.totalOption)
      }
      window.addEventListener('resize', this.totalChart.resize)
    },
    onChange (e, index, item) {
      item.checked = e.target.checked
      this.selectedDataList = this.dataList.filter(data => data.checked)
      const yAxis = []
      const series = []
      this.selectedDataList.forEach((data, index) => {
        data.points = []
        this.historyList.forEach(history => {
          data.points.push([history.time, +history[data.code]])
        })
        yAxis.push({
          type: 'value',
          axisLine: {
            show: true
          },
          axisLabel: {
            show: true
          },
          splitLine: {
            show: false
          },
          position: index % 2 === 0 ? 'left' : 'right',
          offset: (index % 2 === 1 ? index - 1 : index) * 20,
          scale: true
        })
        series.push({
          type: 'line',
          name: data.name,
          data: data.points,
          symbol: 'none',
          yAxisIndex: index,
          lineStyle: {
            width: 2
          }
        })
      })
      this.totalOption.yAxis = yAxis
      this.totalOption.series = series
      this.totalChart.setOption(this.totalOption, { replaceMerge: ['xAxis', 'yAxis', 'series'] })
    },
    onDateChange (dateArray) {
      const startDate = new Date(dateArray[0]).getTime()
      const endDate = new Date(dateArray[1]).getTime() + 24 * 60 * 60 * 1000 - 1
      const reduce = parseInt((endDate - startDate) / 1000 / 60 / 60 / 24)
      if (reduce > 31) {
        return message.warn('日期范围最多一个月')
      }
      this.startDate = startDate
      this.endDate = endDate
    },
    async showCharts (element) {
      this.isChartsShow = true
      const i = this.deviceList.findIndex(item => item.deviceName === element.deviceName)
      this.device = this.deviceList[i]
      this.deviceCode = this.deviceList[i].deviceCode
      this.deviceName = this.deviceList[i].deviceName
      try {
        const result = await deviceApi.getDataPoints(this.deviceCode)
        this.dataPointCode = []
        if (result.data) {
          result.data.points.forEach(item => {
            item.checked = false
            this.dataPointCode.push(item.code)
          })
          this.dataList = result.data.points
        }
        if (result.data === null) {
          this.dataPointCode = []
          this.dataList = []
          this.isChartsShow = false
          return
        }
        const startTime = new Date(this.startDate).getTime()
        const endTime = new Date(this.endDate).getTime()
        const params = {
          deviceCode: this.deviceCode,
          dataPointCode: this.dataPointCode + '',
          startTime,
          endTime
        }
        const historyList = await deviceApi.getHistory(params)
        this.historyList = historyList.data
        this.historyData = []
        const checkbox = document.querySelectorAll('input[type ^= checkbox]')
        checkbox.forEach(item => {
          item.checked = false
        })
      } catch {
        // this.$message.error("请求失败")
      }
      this.initCharts()
      this.drawTotalChart()
    },
    async search () {
      this.isChartsShow = false
      const startTime = new Date(this.startDate).getTime()
      const endTime = new Date(this.endDate).getTime()
      const params = {
        deviceCode: this.deviceCode,
        dataPointCode: this.dataPointCode + '',
        startTime,
        endTime
      }
      try {
        const result = await deviceApi.getHistory(params)
        this.isChartsShow = true
        this.historyList = result.data
        this.historyData = []
        const yAxis = []
        const series = []
        this.selectedDataList.forEach((data, index) => {
          data.points = []
          this.historyList.forEach(history => {
            data.points.push([history.time, +history[data.code]])
          })
          yAxis.push({
            type: 'value',
            axisLine: {
              show: true
            },
            axisLabel: {
              show: true
            },
            splitLine: {
              show: false
            },
            position: index % 2 === 0 ? 'left' : 'right',
            offset: (index % 2 === 1 ? index - 1 : index) * 18,
            scale: true
          })
          series.push({
            type: 'line',
            name: data.name,
            data: data.points,
            symbol: 'none',
            yAxisIndex: index,
            lineStyle: {
              width: 2
            }
          })
        })
        this.totalOption.yAxis = yAxis
        this.totalOption.series = series
        this.totalChart.setOption(this.totalOption, { replaceMerge: ['xAxis', 'yAxis', 'series'] })
        this.initCharts()
      } catch {
        // this.$message.error("请求失败")
      }
    }
  }
}
</script>

<style scoped>

.ant-layout {
  background-color: #2F3D4F;
  overflow: auto;
}
.ant-layout::-webkit-scrollbar {
  width: 8px;
  border-radius: 4px;
}
.ant-layout::-webkit-scrollbar-track {
  width: 8px;
  border-radius: 4px;
}
.ant-layout::-webkit-scrollbar-thumb {
  width: 8px;
  background-color: #4961A3;
  border-radius: 4px;
}
.ant-layout-has-sider {
  margin: 20px 20px;
}
.ant-layout-content {
  height: 825px;
}
.ant-spin-spinning {
  position: absolute;
  top: 500px;
  left: 1130px;
}
.ant-layout-content .img {
  float: left;
  width: 100px;
  height: 80px;
}
.statistics {
  padding: 15px;
}
.header {
  position: relative;
  margin-bottom: 100px;
}
.description {
  height: 80px;
  position: absolute;
  top: 8px;
  left: 125px;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: #EDFAFF;
}
.input {
 margin-left: 400px;
 margin-bottom: 10px;
}
input[type ^= checkbox] {
  width: 18px;
  height: 18px;
  border: none;
  outline: none;
  vertical-align: bottom;
}
.header button {
  background-color: #00ADFF;
  border-radius: 10px;
  border: none;
  height: 40px;
  width: 100px;
  margin-left: 15px;
  line-height: 40px;
  text-align: center;
  color: #EDFAFF;
  cursor: pointer;
}
.ant-layout-content .dataList {
  float: left;
  margin-top: 20px;
  margin-left: 300px;
  padding: 0 !important;
  background-color: #2F3D4F;
}
.ant-layout-content .dataList li {
  list-style: none;
  float: left;
  padding: 10px;
  border: 1px solid #1890ff;
  color: #118BCD;
}
.ant-layout-content .dataList li:hover {
  background-color: #00ADFF;
  color: #EDFAFF;
}
.ant-layout-content .img img {
  width: 100%;
  height: 100%;
}
#components-layout-demo-custom-trigger {
  width: 100%;
  height: 100%;
  margin: 20px 20px;
}
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  margin: 16px;
}
.header {
  height: 80px;
}
.container {
  width: 100%;
  /* height: 700px;
  overflow: auto; */
}
.container::-webkit-scrollbar {
  width: 6px;
  background-color: #ccc;
  border-radius: 3px;
}
.container::-webkit-scrollbar-track {
  width: 6px;
  background-color: #ccc;
  border-radius: 3px;
}
.container::-webkit-scrollbar-thumb {
  width: 6px;
  background-color: #4961A3;
  border-radius: 3px;
}
.charts {
  padding: 20px;
}
.charts li {
  position: relative;
  list-style: none;
  width: 100%;
  height: 300px;
  padding: 20px;
  border: 1px solid #ccc;
}
.charts li h3 {
  color: #A5ABB3;
}
.charts li div {
  position: absolute;
  top: 30px;
  left: 45px;
  padding: 0;
}
</style>
